'use strict';

import 'slick-carousel';
import config from '../../config/config';
import productFlags from '../../spa/components/search/product/components/product-flags';
import util from '../../utils/util';
import enhanceProduct from '../../constructor-io/helpers/enhanceProduct';

const sliderSettings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    rtl: document.documentElement.lang === 'ar' ? true : false,
    infinite: false,
    prevArrow: config.SLICK.PREV_ARROW,
    nextArrow: config.SLICK.NEXT_ARROW,
    variableWidth: true,
    dotsClass: 'slick-dots-custom'
};

/**
 * Replaces PLP product tile price content.
 * @param {jQuery Object} $swatch
 * @param {jQuery Object} $wrapper
 * @returns {void}
 */
const replacePLPPriceContent = ($swatch, $wrapper) => {
    if ($swatch && $swatch.length) {
        const newPriceContent = $swatch.data('price-container');

        if (newPriceContent && newPriceContent.length) {
            const $oldPriceContainer = $wrapper.find('.product-pricing');

            $oldPriceContainer.html(newPriceContent);
        }
    }
};

/**
 * Replaces PLP product tile color name.
 * @param {jQuery Object} $swatch
 * @param {jQuery Object} $wrapper
 * @returns {void}
 */
const replaceProductTileColor = ($swatch, $wrapper) => {
    if ($swatch && $swatch.length) {
        const colorName = $swatch.data('color');

        if (colorName && colorName.length) {
            $wrapper.find('.product-colorname').html(colorName);
        }
    }
};

/**
 * Replaces PLP product flags
 * @param {jQuery Object} $swatch
 * @param {jQuery Object} $wrapper
 * @returns {void}
 */
const replaceProductFlags = ($swatch, $wrapper) => {
    if ($swatch?.length) {
        const flagsData = $swatch.data('flags');
        const flagsWrapper = $wrapper.find('.product-tile-flag.flag-clp');

        if (Array.isArray(flagsData) && flagsData.length) {
            const flagsContent = productFlags(flagsData, 'clp');

            flagsWrapper.replaceWith(flagsContent);
        } else {
            flagsWrapper.html('');
        }
    }
};

const initNewColorSwatches = () => $('.color-swatch-list:not(.slick-initialized)').slick(sliderSettings);
const initHoverImageUpdate = () => {
    let touched = false;
    const $main = $('#main');

    $main.on('touchstart', () => {
        touched = true;
        setTimeout(() => {
            touched = false;
        }, 300);
    });

    $main.on('click', '.color-swatch.mobile-selectable:not(.selected)', e => {
        if (!util.isMobile()) {
            return;
        }

        const $swatch = $(e.currentTarget);
        const $wrapper = $swatch.parents('.product-tile-wrapper');

        const data = $swatch.data('thumb');
        const $hoverContainer = $wrapper.find($swatch.data('hover-container'));
        const $hoverImage = $hoverContainer.find('img');

        $hoverImage.attr('src', data.src);
        $hoverImage.attr('alt', data.alt);
        $hoverImage.attr('title', data.title);

        let $selectedSwatch = $wrapper.find('.color-swatch.selected');
        $selectedSwatch.removeClass('selected');
        $swatch.addClass('selected');
        let productUrl = $swatch.attr('href');
        let $tileElement = $wrapper.find('.product-tile');
        let productID = $swatch.data('product-id');
        let $priceContainer = $($swatch.data('price-container'));
        let productPrice = $priceContainer.data('price');

        $tileElement.attr('href', productUrl);
        $tileElement.attr('data-itemid', productID);
        $wrapper.attr('data-cnstrc-item-id', productID);
        $wrapper.attr('data-cnstrc-item-price', productPrice);

        if (!enhanceProduct.isSliderTilesPLPEnabled()) {
            $hoverImage.one('load', () => $hoverContainer.show());
        }

        replacePLPPriceContent($swatch, $wrapper);
        replaceProductTileColor($swatch, $wrapper);
        replaceProductFlags($swatch, $wrapper);

        if (enhanceProduct.isSliderTilesPLPEnabled()) {
            enhanceProduct.loadSwipeSlider(productID, $wrapper);
        }

        e.preventDefault();
    });

    $main.on('mouseenter', '.color-swatch:not(.selected)', e => {
        const $swatch = $(e.currentTarget);

        if (touched || ($swatch.hasClass('mobile-selectable') && util.isMobile())) {
            return;
        }

        const $wrapper = $swatch.parents('.product-tile-wrapper');

        const data = $swatch.data('thumb');
        const $hoverContainer = $wrapper.find($swatch.data('hover-container'));
        const $hoverImage = $hoverContainer.find('img');

        $hoverImage.attr('src', data.src);
        $hoverImage.attr('alt', data.alt);
        $hoverImage.attr('title', data.title);

        $hoverImage.one('load', () => $hoverContainer.show());

        replacePLPPriceContent($swatch, $wrapper);
        replaceProductTileColor($swatch, $wrapper);
        replaceProductFlags($swatch, $wrapper);
    });

    $main.on('mouseleave', '.color-swatch:not(.selected)', e => {
        const $swatch = $(e.currentTarget);

        if (touched || ($swatch.hasClass('mobile-selectable') && util.isMobile())) {
            return;
        }

        const $wrapper = $swatch.parents('.product-tile-wrapper');

        let $selectedSwatch = $wrapper.find('.color-swatch.selected');

        $wrapper.find('.color-swatch-hover').hide();

        // Revert color and price to selected swatch color.
        if ($selectedSwatch && $selectedSwatch.length) {
            // If the user hovers the image we will have 2 selected swatches.
            if ($selectedSwatch.length > 1) {
                $selectedSwatch = $selectedSwatch.last();
            }

            replacePLPPriceContent($selectedSwatch, $wrapper);
            replaceProductTileColor($selectedSwatch, $wrapper);
            replaceProductFlags($selectedSwatch, $wrapper);
        }
    });
};

export const init = () => {
    $('.color-swatch-list').slick(sliderSettings);

    const $body = $('body');

    $body.on('moreproductsloaded', initNewColorSwatches);
    $body.on('productlistingupdated', initNewColorSwatches);

    initHoverImageUpdate();
};

export const initContainerSwatches = $container =>
    $container.find('.color-swatch-list-hover:not(.slick-initialized)').slick(sliderSettings);
